module.exports = __webpack_public_path__ + "static/media/10.123a96ff.png";